<div class="div-password-recovery" *ngIf="showData">
  <h1 class="title">{{ title | translatePipe }}</h1>
  <div class="password-content">
    <p class="text">{{ 'auth.passwordRecoveryMsg' | translatePipe }}</p>
    <form ngNativeValidate (ngSubmit)="setTenant()" class="row">
      <!-- label>{{ 'auth.passwordRecoveryEmail' | translatePipe }}</label -->
      <app-field-form-select-tenant [name]="'tenantID'" [required]="true" [label]="'tenant'" [myClass]="service.modelClass"></app-field-form-select-tenant>
      <div class="row div-buttons">
        <app-button class="col-6" type="submit" [text]="'auth.passwordRecoverySendCode'"></app-button>
      </div>
    </form>
  </div>
</div>
